import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { config, library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faGithub, faLinkedin, faMedium } from '@fortawesome/free-brands-svg-icons';
import {
  faAngleLeft,
  faAngleRight,
  faEnvelope,
  faLink,
  faFilePdf,
  faMinus,
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import '@fortawesome/fontawesome-svg-core/styles.css';

import './index.scss';
import Footer from '../components/footer';
import Header from '../components/header';

library.add(
  faMedium,
  faFacebook,
  faGithub,
  faLinkedin,
  faEnvelope,
  faLink,
  faFilePdf,
  faMinus,
  faPlus,
  faAngleLeft,
  faAngleRight,
);
config.autoAddCss = false;

const LayoutWrapper = styled.div`
  display: inline-block;
  box-sizing: border-box;
  width: 90%;
  max-width: 1000px;
`;

const Layout = (props) => (
  <LayoutWrapper>
    <Helmet>
      <title>Kartikeya Sharma</title>
      <meta name="description" content="Kartikeya Sharma works on differential privacy, threshold cryptography, and verifiable computation. Sole-authored research on DP-SGD under class imbalance; six peer-reviewed publications on threshold proxy re-encryption." />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Kartikeya Sharma" />
      <meta property="og:title" content="Kartikeya Sharma" />
      <meta property="og:description" content="Kartikeya Sharma works on differential privacy, threshold cryptography, and verifiable computation. Sole-authored research on DP-SGD under class imbalance; six peer-reviewed publications on threshold proxy re-encryption." />
      <meta property="og:url" content="https://sha512rma.eth.limo" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="Kartikeya Sharma" />
      <meta name="twitter:description" content="Kartikeya Sharma works on differential privacy, threshold cryptography, and verifiable computation. Sole-authored research on DP-SGD under class imbalance; six peer-reviewed publications on threshold proxy re-encryption." />
    </Helmet>
    <Header activePage={props.location.pathname} />
    {props.children}
    <Footer activePage={props.location.pathname} />
  </LayoutWrapper>
);

Layout.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.element.isRequired,
};

export default Layout;
